import React from 'react';
import ModalForm from '../Reusable/ModalForm';
import { SubmitButton } from '../../enums/GlobalEnums';
import { ModalForAddOrUpdateUserRole } from '../../enums/UserRoleEnums';

const ModalForUpdateUserRole = ({
  role,
  updateUserRole,
  handleClose,
  show,
  userRoleReducer,
}) => {
  const { error } = userRoleReducer;

  const fields = [
    {
      name: 'roleName',
      label: ModalForAddOrUpdateUserRole.roleNamePlaceholder,
      type: 'text',
    },
  ];

  const initialValues = {
    roleName: role.roleName,
  };

  const handleSubmit = (formData) => {
    const updatedUserRole = {
      id: role.id,
      ...formData,
    };
    updateUserRole(updatedUserRole);
  };

  return (
    <ModalForm
      open={show}
      onClose={handleClose}
      title={ModalForAddOrUpdateUserRole.titleForUpdateRole}
      fields={fields}
      onSubmit={handleSubmit}
      initialValues={initialValues}
      error={error}
      submitLabel={SubmitButton.update}
    />
  );
};

export default ModalForUpdateUserRole;
